export default __webpack_public_path__ + "static/1269-b2d78b2630eeb1db0ce634023e61bbd8.png";